module.exports = __webpack_public_path__ + "img/3.d8e8f0f9.jpg";